// extracted by mini-css-extract-plugin
export default {"tokenEmitterResume":"TokenEmitterResume_tokenEmitterResume__HCvyR"};